import type { AvatarProps } from '@mui/material';
import MuIAvatar from '@mui/material/Avatar';
import { forwardRef } from 'react';

const Avatar = forwardRef<HTMLDivElement, AvatarProps>((props, ref) => {
  return <MuIAvatar ref={ref} {...props} />;
});
export default Avatar;
